
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beverage-disposal",
      function () {
        return require("private-next-pages/beverage-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beverage-disposal"])
      });
    }
  